import { Fragment } from 'react';

import { cx } from '@/ui/classNames';

import styles from './Signature.module.css';

/** La devise de la marque, mots séparés par un « × » violet. */
export function Signature({
  words,
  className,
}: {
  readonly words: readonly string[];
  readonly className?: string;
}) {
  return (
    <p className={cx(styles.signature, className)} aria-label={words.join(', ')}>
      {words.map((word, index) => (
        <Fragment key={word}>
          {index > 0 && (
            <span className={styles.separator} aria-hidden="true">
              ×
            </span>
          )}
          <span className={styles.word} aria-hidden="true">
            {word}
          </span>
        </Fragment>
      ))}
    </p>
  );
}
